<template>
  <!-- 专利信息 -->
  <div>
    <block>
      <div id="patentCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>专利信息 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          prop="applicationdate"
          label="申请日期"
          width="120">
        </el-table-column>
        <el-table-column
          prop="title"
          label="专利名称"
          width="300">
        </el-table-column>
        <el-table-column
          prop="kindcodedesc"
          label="专利类型"
          width="120">
        </el-table-column>
        <el-table-column
          prop="legalstatusdesc"
          label="法律状态详情"
          width="120">
        </el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-image v-if="scope.column.property == 'imageurl'" style="width: 60px; height: 60px" :src="scope.row['imageurl']" fit="contain"></el-image>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="companyAchievementNameClick(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'patent-count',
  props: { companyId: String },
  data () {
    return {
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '申请号',
        property: 'applicationnumber'
      }, {
        label: '公布日期',
        property: 'publicationdate'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    // 点击了 公司名 跳转到公司详情
    companyAchievementNameClick (item) {
      const vm = this
      sessionStorage.removeItem('company-intellectual-details-item')
      sessionStorage.setItem('company-intellectual-details-item', JSON.stringify(item))
      const routeData = vm.$router.resolve({
        name: 'company-patent-details'
      })
      window.open(routeData.href, '_blank')
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/companyIntellectualProperty/getPatentList',
        dateBackgroundRequestType: 'get',
        data: {
          qcc_company_id: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.applicationdate = item.applicationdate ? item.applicationdate.substring(0, 10) : '-'
            item.publicationdate = item.publicationdate ? item.publicationdate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
